import React from 'react';
import { Segment } from 'semantic-ui-react'

/**
 * Delete target from panel component
 */
export default class DeletePanelTarget extends React.Component {

	render() {
		return  <Segment basic>
					<h3>Célpont törlése a panelből</h3>
				</Segment>
	}
}